import { createContext, useContext } from 'react';

/**
 * Whether the screen a tile is on is shown (or sliding in or out). Tiles on other screens keep
 * their data but do not animate and do not play video (proposal §6.5 and §6.7).
 */
export const ScreenActiveContext = createContext(true);

export function useScreenActive() : boolean {
    return useContext(ScreenActiveContext);
}

/** Whether the app is in the foreground (the shell's `lifecycle`, and the page's visibility). */
export const AppForegroundContext = createContext(true);

export function useAppForeground() : boolean {
    return useContext(AppForegroundContext);
}
